import { render, staticRenderFns } from "./ArticlesSections.vue?vue&type=template&id=1db47ade&scoped=true&"
import script from "./ArticlesSections.vue?vue&type=script&lang=js&"
export * from "./ArticlesSections.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesSections.vue?vue&type=style&index=0&id=1db47ade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db47ade",
  null
  
)

export default component.exports